import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Hotkeys from 'react-hot-keys';

import triggerVisitSMS from '../../api/triggerVisitSMS';
import { hideDialog } from '../../store/actions/prescriptionPad';
import { getPrescription } from '../../store/selectors/prescriptionPad';

const ANIMATE_BT_ID = 'animate-btn';

const SendCommunicationDialog: React.FC = () => {
    const [phInput, setPhInput] = useState('');
    const [apiState, setApiState] = useState<'' | 'loading' | 'success' | 'error'>('');

    const onPhChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        if (value && value.length > 0 && isNaN(parseInt(value))) {
            return;
        }

        if (value.length > 10) {
            return;
        }
        setPhInput(value);
    };

    const onPaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
        const v = e.clipboardData.getData('text');
        e.preventDefault();
        e.stopPropagation();

        if (v && v.length >= 10) {
            let t = v.replace(/[^0-9]/g, '').replace('+91', '');
            if (t.length > 10) {
                t = t.substr(t.length - 10);
            }
            if (t.length === 10) {
                setPhInput(t);
            }
        }
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            submit();
        } else if (e.key === 'Escape') {
            e.currentTarget.blur();
        }
    };

    const prescription = useSelector(getPrescription);
    const dispatch = useDispatch();

    const submit = (): void => {
        if (phInput.length !== 10 || !prescription) {
            alert('Please enter a valid 10 digit mobile number');
            return;
        }

        document.getElementById(ANIMATE_BT_ID)?.classList.add('fill');

        triggerVisitSMS(prescription.visitId, `91${phInput}`)
            .then((r) => {
                try {
                    r.wpString &&
                        window.open(
                            `https://api.whatsapp.com/send?phone=91${phInput}&text=${r.wpString}`,
                            '_blank',
                        );
                    setApiState('success');
                    setTimeout(() => {
                        close();
                    }, 2000);
                } catch (e) {
                    console.error('triggerVisitSMS, window.open', e);
                }
            })
            .catch((e) => {
                setApiState('error');
            });
    };

    const close = (): void => {
        dispatch(hideDialog('ph'));
    };

    return (
        <Hotkeys keyName="esc" onKeyDown={close}>
            <div className="modal-show">
                <div onClick={close} className="modal-overlay"></div>
                <div className="modal-content w-30p">
                    <div className="bg-white rounded-8">
                        <div className="flex items-center p-16">
                            <p className="font-700 text-neutral-1 text-18">
                                Enter alternate communication number
                            </p>
                        </div>
                        <div className="w-full border-b border-neutral-7"></div>
                        <div className="px-16 py-24 space-y-16">
                            <div>
                                <div className="ether-input-component border border-neutral-5  focus-within:border-actionPrimary-active  ">
                                    <div className="flex items-center w-full">
                                        <div className="relative flex z-0 w-full text-neutral-5 focus-within:text-actionPrimary-active">
                                            <input
                                                type="number"
                                                placeholder="e.g 7740997399"
                                                maxLength={10}
                                                value={phInput}
                                                onChange={onPhChange}
                                                onPaste={onPaste}
                                                onKeyDown={onKeyDown}
                                            />
                                            <label>Mobile Number</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-between">
                                <div>
                                    <button
                                        onClick={close}
                                        className="neutral-btn px-12 py-8 btn--small"
                                    >
                                        <span className="w-full text-center">Cancel</span>
                                    </button>
                                </div>

                                <div>
                                    {apiState === '' && (
                                        <button
                                            id={ANIMATE_BT_ID}
                                            onClick={submit}
                                            className="relative inline-flex items-center px-12 py-8 text-actionPrimary btn--small btn-custom-actionPrimary focus:outline-none"
                                            // disabled={phInput.length !== 10}
                                        >
                                            <span className="pr-8">
                                                <div
                                                    className="flex items-center justify-center"
                                                    id="send"
                                                >
                                                    <svg
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 28 28"
                                                        id="send"
                                                        className="inline-block fill-actionPrimary"
                                                    >
                                                        <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z"></path>
                                                    </svg>
                                                </div>
                                            </span>
                                            <span className="w-full text-center">
                                                Send SMS/WhatsApp
                                            </span>
                                        </button>
                                    )}
                                    {apiState === 'success' && (
                                        <button className="inline-flex items-center px-12 py-8 bg-white border btn btn--small focus:outline-none font-700 rounded-4 text-status-success border-status-success">
                                            <span className="pr-8">
                                                <div className="flex items-center justify-center w-20 h-20">
                                                    <svg
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 24 24"
                                                        className="fill-status-success"
                                                    >
                                                        <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"></path>
                                                    </svg>
                                                </div>
                                            </span>
                                            <span className="w-full text-center">Sent</span>
                                        </button>
                                    )}
                                    {apiState === 'error' && (
                                        <button className="inline-flex items-center px-12 py-8 bg-white border btn btn--small focus:outline-none font-700 rounded-4 text-status-error border-status-error">
                                            <span className="pr-8">
                                                <div className="flex items-center justify-center w-20 h-20">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 576 512"
                                                        width="16"
                                                        height="20"
                                                        className="fill-status-error"
                                                    >
                                                        <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                                                    </svg>
                                                </div>
                                            </span>
                                            <span className="w-full text-center">Failed</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Hotkeys>
    );
};

export default SendCommunicationDialog;
